import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.26463 17.7891C9.82262 17.7891 10.2754 18.2413 10.2754 18.7998C10.2754 19.3576 9.82321 19.8106 9.26463 19.8106C8.70604 19.8106 8.25386 19.3576 8.25386 18.7998C8.25386 18.2413 8.70664 17.7891 9.26463 17.7891Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.26463 11.7656C9.82262 11.7656 10.2754 12.2179 10.2754 12.7763C10.2754 13.3342 9.82321 13.7872 9.26463 13.7872C8.70604 13.7872 8.25386 13.3342 8.25386 12.7763C8.25386 12.2179 8.70664 11.7656 9.26463 11.7656Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.26463 5.74609C9.82262 5.74609 10.2754 6.19833 10.2754 6.75679C10.2754 7.31467 9.82321 7.76765 9.26463 7.76765C8.70604 7.76765 8.25386 7.31467 8.25386 6.75679C8.25386 6.19832 8.70664 5.74609 9.26463 5.74609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.7353 17.7891C16.2933 17.7891 16.7461 18.2413 16.7461 18.7998C16.7461 19.3576 16.2939 19.8106 15.7353 19.8106C15.1767 19.8106 14.7246 19.3576 14.7246 18.7998C14.7246 18.2413 15.1773 17.7891 15.7353 17.7891Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.7353 11.7656C16.2933 11.7656 16.7461 12.2179 16.7461 12.7763C16.7461 13.3342 16.2939 13.7872 15.7353 13.7872C15.1767 13.7872 14.7246 13.3342 14.7246 12.7763C14.7246 12.2179 15.1773 11.7656 15.7353 11.7656Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.7353 5.74609C16.2933 5.74609 16.7461 6.19833 16.7461 6.75679C16.7461 7.31467 16.2939 7.76765 15.7353 7.76765C15.1767 7.76765 14.7246 7.31467 14.7246 6.75679C14.7246 6.19832 15.1773 5.74609 15.7353 5.74609Z",
			fill: "currentColor"
		})
	]
});
export default SvgMenuLine;
